import { SVGIconComponent } from './types';

export const LockerL: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 36"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_locker-L">
      <g id="locker-L" transform="translate(0.000000, 0.000000)">
        <g id="L">
          <path
            id="path-1_00000119083165235249330780000015569230741218344610_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M12.8,0l11.5,5.5c0.2,0.1,0.3,0.3,0.3,0.5
				l0,20.8c0,0.2-0.1,0.3-0.2,0.4l-11.6,8.4l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
				c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0
				c0,0,0,0,0,0l-12-6.9C0.1,28.7,0,28.5,0,28.3V7.9c0-0.3,0.2-0.5,0.4-0.5l11.9-7.3C12.5,0,12.7,0,12.8,0z M1,8.8V28l11,6.3V14.9
				L1,8.8z M23.6,7.2L13,14.8v19.4l10.6-7.6V7.2z M12.6,1.1L1.5,7.9L12.4,14l10.7-7.8L12.6,1.1z"
          />
        </g>
        <polygon
          id="L_00000016074486975877385510000004390184100192372644_"
          fill="currentColor"
          points="14.4,10.6 14.4,9.8 11.9,9.8 11.9,5 
			10.9,5 10.9,10.6 		"
        />
      </g>
    </g>
  </svg>
);
